import type { QueryResult } from '@apollo/client';
import { useQuery } from '@apollo/client';

import { setLocalizationCountryCookie } from '@app/helpers/localization';

import type { LocalizationCountryQuery } from './__generated__/LocalizationCountryQuery';
import { LOCALIZATION_COUNTRY_QUERY } from './queries';

const useLocalizationCountry = (): UseLocalizationCountryResult => {
  const { data, ...queryState } = useQuery<LocalizationCountryQuery>(
    LOCALIZATION_COUNTRY_QUERY,
  );

  return {
    ...queryState,
    setLocalizationCountry: setLocalizationCountryCookie,
    country: data?.localizationCountry,
  };
};

export default useLocalizationCountry;

interface UseLocalizationCountryResult
  extends Omit<QueryResult<LocalizationCountryQuery>, 'data'> {
  country?: string;
  setLocalizationCountry: (country: string) => void;
}
